/* ==========================================================================
   <floating-assistant> — a floating help bubble with a slide-up action panel.
   ========================================================================== */
(function () {
  'use strict';

  class FloatingAssistant extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.toggle = this.querySelector('[data-fa-toggle]');
      this.panel = this.querySelector('[data-fa-panel]');
      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', function () { self.setOpen(!self.isOpen()); });

      // Close on outside click / Escape
      document.addEventListener('click', function (e) {
        if (self.isOpen() && !self.contains(e.target)) self.setOpen(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen()) { self.setOpen(false); self.toggle.focus(); }
      });

      // Coupon copy-to-clipboard
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fa-copy]');
        if (!btn) return;
        var code = btn.getAttribute('data-fa-copy');
        var done = function () {
          btn.classList.add('is-copied');
          var hint = btn.querySelector('[data-fa-copy-hint]');
          if (hint) { hint.dataset.orig = hint.dataset.orig || hint.textContent; hint.textContent = 'Copied!'; }
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (hint && hint.dataset.orig) hint.textContent = hint.dataset.orig;
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    }

    isOpen() { return this.classList.contains('is-open'); }

    setOpen(open) {
      this.classList.toggle('is-open', open);
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var first = this.panel.querySelector('a, button, summary');
        if (first) first.focus();
      }
    }
  }

  if (!customElements.get('floating-assistant')) {
    customElements.define('floating-assistant', FloatingAssistant);
  }
})();
